new basictable('.html-area > table:not(.MsoNormalTable)', {
    breakpoint: 1023,
    tableWrap: true
})